import * as types from "./types";
import {
    getLeaveRequestListAxios,
    // deleteLeaveRequestAxios,
    postLeaveRequestAxios,
    putLeaveRequestAxios,
    //getLeaveRequestByIDAxios,
    putLeaveRequestApprovalAxios,
    getLeaveRequestEmployeeAxios,
    getLeaveRequestSubordinatesAxios
} from "./services";

export async function getLeaveRequestListAction({ commit }) {
    commit(types.LOADING_LEAVEREQUEST, true);
    try {
        const { data } = await getLeaveRequestListAxios();
        commit(types.GET_LEAVEREQUEST_LIST, data.result.data);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_LEAVEREQUEST, false);
    }
}

// export async function removeLeaveRequestAction({ commit }, payload) {
//     commit(types.LOADING_LEAVEREQUEST, true);
//     try {
//         await deleteLeaveRequestAxios(payload);
//         commit(types.REMOVE_LEAVEREQUEST, payload);
//     }
//     catch (e) {
//         throw e;
//     }
//     finally {
//         commit(types.LOADING_LEAVEREQUEST, false);
//     }
// }

export async function addLeaveRequestAction({ commit }, payload) {
    commit(types.LOADING_LEAVEREQUEST, true);
    try {
        // await postLeaveRequestAxios(payload);
        // commit(types.ADD_LEAVEREQUEST, payload);
        const { data } = await postLeaveRequestAxios(payload);
        commit(types.ADD_LEAVEREQUEST, payload);
        return data;
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_LEAVEREQUEST, false);
    }
}

export async function updateLeaveRequestAction({ commit }, payload) {
    console.log("🚀 ~ updateLeaveRequestAction ~ payload:", payload)
    commit(types.LOADING_LEAVEREQUEST, true);
    try {
        const { data } = await putLeaveRequestAxios(payload);
        commit(types.UPDATE_LEAVEREQUEST, payload);
        return data;
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_LEAVEREQUEST, false);
    }
}


// export async function getLeaveRequestByIDAction({commit}, payload) {
//     commit(types.LOADING_LEAVEREQUEST, true);
//     try {
        
//         const {data} = await getLeaveRequestByIDAxios(payload);
//         commit(types.GET_LEAVEREQUESTBYID, data.result);
//     }
//     catch(e) {
//         throw e;
//     }
//     finally {
//         commit(types.LOADING_LEAVEREQUEST, false);
//     }
// }

export async function putLeaveRequestApprovalAction({ commit }, payload) {
    commit(types.LOADING_LEAVEREQUEST, true);
    try {
      await putLeaveRequestApprovalAxios(payload);
      commit(types.APPROVAL_LEAVEREQUEST, payload);
    } catch (e) {
      console.log(e);
      throw e;
    }
    commit(types.LOADING_LEAVEREQUEST, false);
  }

  export async function getLeaveRequestEmployeeAction({ commit }) {
    commit(types.LOADING_LEAVEREQUEST, true);
    try {
        const { data } = await getLeaveRequestEmployeeAxios();
        commit(types.GET_LEAVEREQUEST_EMPLOYEE, data.result);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_LEAVEREQUEST, false);
    }
}

export async function getLeaveRequestSubordinatesAction({ commit }) {
    commit(types.LOADING_LEAVEREQUEST, true);
    try {
        const { data } = await getLeaveRequestSubordinatesAxios();
        commit(types.GET_LEAVEREQUEST_SUBORDINATES, data.result);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_LEAVEREQUEST, false);
    }
}